import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';

import { Store, select } from '@ngrx/store';
import { IncidentCategoryDto } from '@cradua/data';
import { Observable } from 'rxjs/internal/Observable';
import { routeAnimations, ROUTE_ANIMATIONS_ELEMENTS } from 'libs/core/src/lib/animations';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';

@Component({
  selector: 'cradua-incidentcategory-container',
  templateUrl: './incidentcategory-container.component.html',
  styleUrls: ['./incidentcategory-container.component.scss']
})
export class IncidentCategoryContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  incidentcategorys$: Observable<IncidentCategoryDto[]>;
  loading: boolean;
  isLoading$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.isLoading$ = this.gatwayFacade.isLoadingGateway("IncidentCategory");
    this.incidentcategorys$ = this.gatwayFacade.loadGateway("IncidentCategory");
    this.incidentcategorys$.subscribe(data => {
      console.log("data: cont.",data);

    })
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteIncidentCategory(deletedValue: any) {
    this.gatwayFacade.remove("IncidentCategory", deletedValue);
    // this.store.dispatch(IncidentCategoryStoreActions.removeIncidentCategory({ids: deletedValue}));
    this.notificationService.success('Deleted Successfully');
  }


// this method control both the create and update

  onSubmitIncidentCategory(formValue: any) {
    console.log("form value: ", formValue);
    formValue.IncidentCategorys = formValue.IncidentCategorys.reverse();
    event.preventDefault();
    const pullData = formValue.IncidentCategorys;
    //const newPullData = formValue.IncidentCategoryes;

// declare two empty array to hold update and create data
  let allUpdates = [] ;
  let addAllIncidentCategory = [];


// loop through the form data to check for update and create

  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id !== null) {
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      addAllIncidentCategory.push(pullData[i]);
    }
  }

// check if the addAllIncidentCategory array is not empty, then dispatch the data to the store
   if(addAllIncidentCategory.length !== 0) {
    this.gatwayFacade.add('IncidentCategory', addAllIncidentCategory);
    // this.store.dispatch(IncidentCategoryStoreActions.addIncidentCategory({newIncidentCategory: addAllIncidentCategory}));

   }

// dispatch update data to the store
this.gatwayFacade.update('IncidentCategory', allUpdates, ['id']);
    // this.store.dispatch(IncidentCategoryStoreActions.updateIncidentCategory({updateIncidentCategory: allUpdates}));
    this.notificationService.success('Saved Successfully');

  }

}



